module.exports = new __parcel__URL__("obs.c2e6da15.svg").toString();